import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import HIPPA from '../../../image/HIPAA.png';
import './style.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      signIn: false,
      signUp: false,
    };
  }

  componentDidMount() {
    if (localStorage.getItem('isLoggedin')) {
      this.setState({
        isLoggedIn: true,
      });
    }
    const path = this.props && this.props.match ? this.props.match.path : '';
    if (path === '/signin' || path === '/') {
      this.setState({
        signIn: true,
      });
    }
    if (path === '/signup') {
      this.setState({
        signUp: true,
      });
    }
  }

  render() {
    const { isLoggedIn, signIn, signUp } = this.state;
    return (
      <div className='admin-header'>
        <div
          id='header'
          className='full-header transparent-header dark'
          data-sticky-classname='not-dark'
        >
          <div id='header-wrap'>
            <div className='container clearfix'>
              <div id='primary-menu-trigger'>
                <i className='icon-reorder' />
              </div>

              <div id='logo'>
                <a
                  href='/'
                  className='standard-logo'
                  data-dark-logo='images/swasth-clinicians.png'
                  style={{ height: '65%' }}
                >
                  <img src={require('../../../image/swasth-clinicians.png')} alt='Canvas Logo' />
                </a>
              </div>

              <nav id='primary-menu' className='not-dark with-arrows'>
                <div className='ul'>
                  <div className='li' hidden={signUp || signIn}>
                    <a href='/'>
                      <div>Features</div>
                    </a>
                  </div>
                  <div
                    className='li'
                    onClick={() => this.props.history.push('/pricing')}
                    hidden={signUp || signIn}
                  >
                    <a>
                      <div>Pricing</div>
                    </a>
                  </div>
                  {/*
                                    <div className="li" hidden={signUp || signIn}><a href="#"><div>FAQ</div></a></div>
                                    <div className="li" hidden={signUp || signIn}><a href="#"><div>Blog</div></a></div>
                                    <div className="li" hidden={signUp || signIn}><a href=""><div>Clients</div></a></div>
                                */}
                  <div className='li'>
                    <a
                      href='https://help.swasth.co/topics/access-to-clinician-app'
                      target='_blank'
                      rel='noreferrer'
                    >
                      <div>Help</div>
                    </a>
                  </div>
                  {isLoggedIn ? (
                    <div className='li' onClick={() => this.props.history.push('/app')}>
                      <a>
                        <div>Dashboard</div>
                      </a>
                    </div>
                  ) : (
                    <div>
                      <div className='li' onClick={() => this.props.history.push('/signin')}>
                        <a>
                          <div>Login</div>
                        </a>
                      </div>
                      <div
                        className='li'
                        hidden={this.props.isSignup}
                        onClick={() => this.props.history.push('/signup')}
                      >
                        <a>Signup</a>
                      </div>
                    </div>
                  )}
                  <div className='li' hidden={!(signUp || signIn)} style={{ height: '65%' }}>
                    <div className='image-container'>
                      <img src={HIPPA} alt='HIPAA Logo' className='header-item-image' />
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
